<script>
	export let company_data;

	let company_name = company_data.name;

	let y;

	function scrowTo(elementId) {
		let element = document.getElementById(elementId)
		if (element){
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	function changeMenuColor(y) {
		if (y == 0) {
			return "menu-light";
		} else {
			return "menu-dark";
		}
	}

	function changeLinkColor(y) {
		if (y == 0) {
			return "link-dark";
		} else {
			return "link-light";
		}
	}

	$: menuColorClass = changeMenuColor(y);
	$: linkColorClass = changeLinkColor(y);
</script>

<style>
	.menu-light {
		background-color: transparent !important;
	}
	.menu-dark {
		background-color: #000000cb !important;
		box-shadow: 0 2px 4px 0 rgba(255, 255, 255, 0.2);
	}
	.link-light {
		color: #ffffffcb !important;
	}
	.link-principal {
		color: #f50707cb !important;
	}
	.link-dark {
		color: #000000cb !important;
	}
	.link-font {
		font-family: "Poppins",sans-serif;
		font-size: 12px;
		font-weight: 400;
    	text-transform: uppercase;
		outline: none;
	}

	@media (max-width: 991.98px) {
		.menu-light {
			background-color: #000000cb !important;
			box-shadow: 0 2px 4px 0 rgba(255, 255, 255, 0.2);
		}
		.link-dark {
			color: #ffffffcb !important;
		}
		.navbar-toggler {
			border: none;
		}
	}
</style>

<svelte:window bind:scrollY={y} />

<main>
	<nav class="navbar fixed-top navbar-expand-lg navbar-dark {menuColorClass}">
		<div class="container">
			<a class="navbar-brand" href="#home">
				<img src="img/logo.png" alt="" width="50" />
			</a>
			<button
				class="navbar-toggler"
				type="button"
				data-toggle="collapse"
				data-target="#navbarNavDropdown"
				aria-controls="navbarNavDropdown"
				aria-expanded="false"
				aria-label="Toggle navigation">
				<span class="navbar-toggler-icon" />
			</button>
			<div class="collapse navbar-collapse" id="navbarNavDropdown">
				<ul class="navbar-nav ml-auto">
					<li class="nav-item active">
						<!-- svelte-ignore a11y-missing-attribute -->
						<a class="nav-link link-font link-principal" style="cursor:pointer;" on:click={()=>scrowTo('home')} data-toggle="collapse" data-target=".navbar-collapse.show">{company_name}</a>
					</li>
					<li class="nav-item">
						<!-- svelte-ignore a11y-missing-attribute -->
						<a class="nav-link link-font {linkColorClass}" style="cursor:pointer;" on:click={()=>scrowTo('monte-seu-pedido')} data-toggle="collapse" data-target=".navbar-collapse.show">Como fazer o Pedido</a>
					</li>
					<li class="nav-item">
						<!-- svelte-ignore a11y-missing-attribute -->
						<a class="nav-link link-font {linkColorClass}" style="cursor:pointer;" on:click={()=>scrowTo('pratos-principais')} data-toggle="collapse" data-target=".navbar-collapse.show">Cardápio</a>
					</li>
					<li class="nav-item">
						<!-- svelte-ignore a11y-missing-attribute -->
						<a class="nav-link link-font {linkColorClass}" style="cursor:pointer;" on:click={()=>scrowTo('acompanhamentos')} data-toggle="collapse" data-target=".navbar-collapse.show">Acompanhamentos</a>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</main>
